var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_2407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3827 13.8825C33.1975 12.9138 30.854 12.2001 28.404 11.7914C28.3594 11.7835 28.3148 11.8032 28.2919 11.8427C27.9905 12.3605 27.6565 13.0361 27.4229 13.5671C24.7875 13.1859 22.1659 13.1859 19.5847 13.5671C19.3508 13.0243 19.0049 12.3605 18.7021 11.8427C18.6792 11.8045 18.6346 11.7848 18.5899 11.7914C16.1411 12.1988 13.7978 12.9125 11.6112 13.8825C11.5922 13.8904 11.576 13.9036 11.5652 13.9206C7.1204 20.336 5.90276 26.5937 6.50008 32.7739C6.50279 32.804 6.52036 32.833 6.54469 32.8514C9.47728 34.932 12.318 36.1951 15.106 37.0323C15.1506 37.0455 15.1978 37.0298 15.2262 36.9943C15.8857 36.1241 16.4736 35.2068 16.9777 34.242C17.0074 34.1854 16.979 34.1184 16.9182 34.0961C15.9857 33.7543 15.0978 33.3377 14.2437 32.8646C14.1762 32.8263 14.1708 32.7331 14.2329 32.6883C14.4126 32.5582 14.5924 32.4228 14.7641 32.2862C14.7951 32.2613 14.8384 32.256 14.8749 32.2718C20.486 34.7467 26.5606 34.7467 32.1055 32.2718C32.142 32.2546 32.1852 32.2599 32.2176 32.2848C32.3893 32.4216 32.569 32.5582 32.7502 32.6883C32.8123 32.7331 32.8083 32.8263 32.7406 32.8646C31.8865 33.3468 30.9987 33.7543 30.0648 34.0947C30.0041 34.1172 29.977 34.1854 30.0068 34.242C30.5216 35.2054 31.1095 36.1227 31.7568 36.9929C31.7839 37.0298 31.8325 37.0455 31.8771 37.0323C34.6786 36.1951 37.5193 34.932 40.4518 32.8514C40.4775 32.833 40.4938 32.8054 40.4965 32.7751C41.2114 25.6303 39.2991 19.4239 35.4272 13.922C35.4178 13.9036 35.4017 13.8904 35.3827 13.8825ZM17.8155 29.0108C16.1263 29.0108 14.7343 27.5124 14.7343 25.6723C14.7343 23.8322 16.0993 22.3339 17.8155 22.3339C19.5454 22.3339 20.9239 23.8454 20.8968 25.6723C20.8968 27.5124 19.5319 29.0108 17.8155 29.0108ZM29.208 29.0108C27.5187 29.0108 26.1269 27.5124 26.1269 25.6723C26.1269 23.8322 27.4918 22.3339 29.208 22.3339C30.9379 22.3339 32.3163 23.8454 32.2894 25.6723C32.2894 27.5124 30.9379 29.0108 29.208 29.0108Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_2407",
    x: 6.3584,
    y: 11.7897,
    width: 35.9999,
    height: 26.9616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.71429,
    dy: 1.71429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_2407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_2407",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.ec99bb9eaae56abae0dd93ac2edf39f9.svg";
export { ForwardRef as ReactComponent };